import template from './chargecode-report.html';
import controller from './chargecode-report.controller';

let chargecodeReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default chargecodeReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/chargecode-report/chargecode-report.component.js